<template>
  <div>
    <form @submit.prevent="submit()" class="form">

      <div class="field">
        <label class="label">タイトル</label>
        <div class="control">
          <input class="input" type="text" v-model="form.title">
        </div>
      </div>

      <button class="button is-primary" type="submit">更新する</button>
    </form>
  </div>
</template>

<script>
import axios from '@/axios'

export default {
  props: ['survey'],

  data() {
    return {
      form: {
        title: this.survey.title,
      },
    }
  },

  methods: {
    submit() {
      axios.patch('/api/app/surveys/' + this.survey.id, this.form).then(() => {
        this.$parent.close()
      })
    },
  }
}
</script>

<style scoped>
</style>
